import React from "react";
import NavIndex from "./components/Navbar/NavIndex";
import Banner from "./components/Banner/Banner";
import Footer from "./components/Footer/Footer";
import Login from "./components/Login/Login";
import AssessmentIndex from "./components/MainArea/Assessments/index";
import ConfigurationIndex from "./components/MainArea/Configuration/Index";
import CurriculumIndex from "./components/MainArea/Curriculum/index";
import AttainmentIndex from "./components/MainArea/Attainment/index";
import DashboardIndex from "./components/MainArea/Dashboard/index";
import FacultyContributionIndex from "./components/MainArea/FacultyContribution/index";
import ReportsIndex from "./components/MainArea/Reports/index";
import SurveyIndex from "./components/MainArea/Survey/index";
import UtilitiesIndex from "./components/MainArea/Utilities/index";
import SignLoader from "./components/Loader/SignLoader";
import axios from 'axios'
import './index.css';

import { Route,Redirect, BrowserRouter as Router, Switch } from "react-router-dom";


import { connect } from 'react-redux';
import store from './redux/store'
import Swal from 'sweetalert2'

axios.defaults.baseURL = 'https://nba-stage.herokuapp.com/'

const token = localStorage.getItem("token");

if(token){
    store.dispatch({type:"SET_AUTH",payload:true})
    axios.defaults.headers.common["Authorization"] = "token "+ localStorage.getItem("token");
  }


function App(props) {
    const {success_message,error_message} =   props.ui
    const success = (message)=>{
    Swal.fire({
    position: 'center',
    title:message,
    showConfirmButton: false,
    timer: 2000
    })
    store.dispatch({type:'SUCCESS_DATA',payload:{data:''}})
    }
  const error = (message)=>{
    Swal.fire({
    position: 'center',
    title:message,
    showConfirmButton: false,
    timer: 2000,
    })
    store.dispatch({type:'ERROR_DATA',payload:{data:''}})
    }
  return (
    <div className="App">
    {success_message.general!=undefined?
      success(success_message.general)
    :''}
    {error_message.error!=undefined?
      error(error_message.error)
    :''}
      <Router>
        <Banner />
        <NavIndex />
        <SignLoader/>
        <Switch>
          <Route exact path="/" component={Login} />
          {props.auth?
          <>
          {/* <Route  path="/home" component={HomeIndex} /> */}
          <Route  path="/dashboard" component={DashboardIndex} />
          <Route  path="/attainment" component={AttainmentIndex} />
          <Route  path="/reports" component={ReportsIndex} />
          <Route  path="/configuration" component={ConfigurationIndex} />
          <Route  path="/survey" component={SurveyIndex} />
          <Route  path="/faculty-contribution" component={FacultyContributionIndex}/>
          <Route  path="/utilities" component={UtilitiesIndex} />
          <Route  path="/assessments" component={AssessmentIndex} />
          <Route  path="/curriculum" component={CurriculumIndex} />
          </>
          :<Redirect to='/'/>
          }
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

const mapPropsWithState = (state)=>({
  ui:state.UI,
  auth:state.user.auth
})
export default connect(mapPropsWithState)(App);
